import { RemoteAdvertisingCreate } from 'data/usecases';
import { AdvertisingCreateUseCaseInterface } from 'domain/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeAdvertisingCreate = (): AdvertisingCreateUseCaseInterface =>
  new RemoteAdvertisingCreate(makeApiUrlEntities(), makeAxiosHttpClient());
